var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c(
      "div",
      { staticClass: "cards card--list row" },
      [
        _vm.filters
          ? _c("filter-sidebar", { attrs: { filters: _vm.filters } })
          : _vm._e(),
        _vm._v(" "),
        _vm.sidebar !== null
          ? _c(
              "div",
              { staticClass: "section-menu col-md-3 order-1 order-md-2" },
              [
                _c("side-menu", {
                  attrs: {
                    sidebar: _vm.sidebar,
                    hideChildren: _vm.sidebarHideChildren,
                    header: _vm.sidebarHeader
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.listing.length > 0
          ? _c(
              "div",
              {
                class:
                  _vm.sidebar !== null
                    ? "col-md-9 order-3"
                    : "col-md-12 order-3"
              },
              [
                _vm._l(_vm.listing, function(item, index) {
                  return _c("advocacy-alert-item", {
                    key: item.DetailID,
                    attrs: { item: item, displaySummary: _vm.displaySummary }
                  })
                }),
                _vm._v(" "),
                _vm.listing.length > 0 && _vm.pagination.totalPages > 1
                  ? _c(
                      "section",
                      { staticClass: "pt-3 pb-5 pt-md-4 pb-md-4" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [_c("pagination")],
                            1
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.listing.length === 0
          ? _c(
              "div",
              { staticClass: "col-md-9 align-center no-results order-3" },
              [
                _c("h2", { staticClass: "not-found-heading" }, [
                  _vm._v(
                    "Sorry, no items were found matching your specifications."
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Try removing some filters or searching a different term."
                  )
                ])
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }